import { Flex, createStyles } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { useUserAccount } from '../../../api';
import { DevPanel } from '../../../components/DevPanel/DevPanel';
import { IS_PRODUCTION } from '../../../utils/envs';
import { HelpMenu } from './HelpMenu';

const useStyles = createStyles((theme) => ({
	button: {
		pointerEvents: 'auto',
	},
	circleIconButton: {
		pointerEvents: 'auto',
		borderRadius: theme.other.borderRadius.lg,
	},
	floatingFooter: {
		pointerEvents: 'none',
		position: 'absolute',
		bottom: theme.spacing.sm,
		width: `calc(100% - ${theme.spacing.md})`,
		flexDirection: 'row',
		paddingRight: theme.spacing.xs,
		justifyContent: 'space-between',
		alignContent: 'space-between',
		gap: theme.spacing.md,
	},
}));

function SideBarFooter() {
	const { classes } = useStyles();
	const { data: userAccount } = useUserAccount();

	const canShowDevPanel = userAccount?.is_superuser || !IS_PRODUCTION;

	return (
		<Flex className={classes.floatingFooter}>
			<HelpMenu />
			{canShowDevPanel && <DevPanel />}
			{/* Trial indicator hidden per request */}
			{/* {trial && (
				<Button
					leftIconName="circleArrowUp"
					onClick={() => navigate('/plans')}
					className={classes.button}
					data-testid="trial-button"
				>
					{trialMessage}
				</Button>
			)} */}
		</Flex>
	);
}

const ObservedSideBarFooter = observer(SideBarFooter);
export default ObservedSideBarFooter;
